import { TWhiteLabel } from '../white-label.model';
import { getDefaultPanelColors } from './get-default-panel-colors';
import { isChosenColor } from './is-chosen-color';
import { resolveIconActiveColorPanel } from './resolve-icon-active-color-panel';

export function resolveNavItemPanelToggleIcon(whiteLabelData: TWhiteLabel): string {
  const defaultPanelColors = getDefaultPanelColors();

  if (!isChosenColor(whiteLabelData.panelFont, defaultPanelColors.panelFont)) {
    return '';
  }

  return resolveIconActiveColorPanel(whiteLabelData);
}
